import styled from "styled-components"

import { Bounds, Box } from "../grid"
import { BaseContainer } from "../container"
import { Button } from "../inputs"
import { textColor, colors, devices } from "../../utils/styleVariables"
import { setColor } from "../../utils/styleFunctions"
import { PricingHeader, FontIcon } from "../typography"

const colorEnum = {
  simple: ["#fff", colors.lightBlue],
  pro: ["#fff", colors.purple],
  awesome: ["#fff", colors.darkBlue],
}

const Ticks = styled(FontIcon)`
  color: ${props =>
    props.slug
      ? setColor(colorEnum[props.slug][1])
      : setColor(textColor.text, 0.5)};
`

const TableContainer = styled(BaseContainer)`
  flex-wrap: wrap;

  @media ${devices.tabletOnly} {
    margin-left: 35px;
    margin-right: 35px;
  }
`

const TableItem = styled.div`
  position: relative;
  border-radius: 5px;
  padding-right: 8px;
  margin: 8px;
  padding-left: 8px;
  box-shadow: rgba(0, 0, 0, 20%) 0 1px 3px;
  width: 100%;

  @media ${devices.tablet} {
    width: ${props => props.tabletWidth || "calc(33.3333333% - 24px)"};
    margin: 0 8px;
  }
  @media ${devices.laptop} {
    ${props => props.desktopWidth && `width: ${props.desktopWidth}`};
    padding-right: 24px;
    padding-left: 24px;
  }
`

const TableFeatures = styled.ul`
  margin: 0 2.5px;
  padding-top: 12px;
  padding-bottom: 12px;
`

const FeatureRow = styled.li`
  margin: 0;
  padding: 12px 24px;
`

const PlanContainer = styled.div`
  align-items: center;
  flex-direction: column;
  width: 100%;
`

const PlanBody = styled(Bounds)`
  height: ${props => (props.opened ? "auto" : 0)};
  display: ${props => (props.opened ? "block" : "none")};
`

const PlanHeader = styled(Bounds)`
  justify-content: space-between;
  align-items: center;
  margin: 24px 12px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

const TitleHeader = styled(Bounds)`
  ${props => props.shouldOpenable && "text-align: center"};
width: ${props => props.shouldOpenable ? "auto" : "100%"};
`

const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  width: 200px;
  margin: 0 auto;
  justify-content: space-between;
  border-top: 1px solid #e8e8e8;
  padding: 20px 10px;
`

const DropdownButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  svg {
    transform: ${props => (props.opened ? "rotate(180deg)" : "none")};
  }
`

const PricingHeaderLeft = styled(PricingHeader)`
  & .sub {
    font-size: 1.6rem;
  }
`

const PlanIllustration = styled.div`
  justify-content: center;
  align-items: center;
  height: 380px;
  margin-top: 40px;
  margin-bottom: 55px;

  .gatsby-image-wrapper {
    width: 100%;
  }
`

const PlanButton = styled(Button)`
  width: 40%;
  margin: 0 auto;
  background-color: ${props => setColor(colorEnum[props.slug][1])};
  color: ${props => colorEnum[props.slug][0]};
  @media ${devices.tablet} {
    width: auto;
    margin: 0;
  }
`

const FeatureList = styled.div`
  border-radius: 5px;
  background-color: #fff;
  color: ${setColor(textColor.text)};
`

const FeatureTitle = styled(Box)`
  display: flex;
  align-items: center;
  color: ${props =>
    props.slug ? setColor(textColor.text, 0.9) : setColor(textColor.text, 0.5)};
  & span {
    margin-left: 10px;
  }
  & p {
    display: inline-block;
  }
`

const SwitchContainer = styled(Bounds).attrs(props => {
  const width = 100
  const basePosition = width * props.step

  return {
    right: props =>
      props.step > 0 ? `${basePosition + 4 * props.steps}px` : "4px",
    width: `${width}px`,
    containerWidth: `${(width + 8) * props.steps}px`,
  }
})`
  position: relative;
  width: ${props => props.containerWidth};
  height: 42px;
  border: 2px solid #444;
  border-radius: 21px;
  padding: 4px;
  justify-content: space-around;
  align-items: center;
  margin-right: 8px;

  input {
    display: none;
  }

  label {
    display: inline-block;
    text-align: center;
    width: ${props => props.width}
  }

  label[for=${props => "choice_" + props.step}] {
    color: #fff;
  }

  .slider {
    position: absolute;
    z-index: -1000;
    right: ${props => props.right};
    top: 4px;
    bottom: 4px;
    width: ${props => props.width};
    background-color: #444;
    border-radius: 21px;
    transition: right 0.1s ease-in-out;
  }
`

export {
  Ticks,
  TableContainer,
  TableItem,
  TableFeatures,
  FeatureRow,
  PlanContainer,
  PlanHeader,
  TitleHeader,
  DropdownContainer,
  DropdownButton,
  PlanBody,
  PricingHeaderLeft,
  PlanIllustration,
  PlanButton,
  FeatureList,
  FeatureTitle,
  SwitchContainer,
}
